import { useEffect, useState } from 'react'

export function useDraft<T>(key: string, initialValue: T) {
  const storageKey = `ess-draft:v1:${key}`
  const [value, setValue] = useState<T>(() => {
    try {
      const saved = localStorage.getItem(storageKey)
      return saved ? (JSON.parse(saved) as T) : initialValue
    } catch {
      return initialValue
    }
  })

  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(value))
  }, [storageKey, value])

  const clear = () => localStorage.removeItem(storageKey)
  return [value, setValue, clear] as const
}
